// Review dates for the commercial hub pages.
//
// CommonJS on purpose, for the same reason as helpers/blog-pagination.js: the
// sitemap generator in nuxt.config.js needs these values and cannot import an
// ES module, while webpack resolves the named imports for the Vue pages.
//
// Each date is both the "Last reviewed" line under the page's H1 and the
// <lastmod> the sitemap publishes for it. Keeping them as one value is the
// point — a page that says it was reviewed today while the sitemap claims it
// last changed a year ago is a contradiction Google can see.
//
// Bump a date when the page's copy, prices or cover claims change; leave it
// alone for styling-only edits.
const HUB_PAGES = {
  '/bike-insurance': '2026-10-27',
  '/what-we-cover': '2026-10-27',
  '/bike-theft-insurance': '2026-10-27',
  '/electric-bike-insurance': '2026-10-27',
}

function hubPageLastmod(path) {
  return HUB_PAGES[path]
}

// The [{ url, lastmod }] shape @nuxtjs/sitemap wants.
function hubPageSitemapRoutes() {
  return Object.keys(HUB_PAGES).map((url) => ({
    url,
    lastmod: HUB_PAGES[url],
  }))
}

module.exports = { HUB_PAGES, hubPageLastmod, hubPageSitemapRoutes }
